import React from 'react'

import { Skeleton } from 'components'

import { getLabel } from 'helpers/language'

export interface TicketLabelProps {
  isLoading?: boolean
  isRow?: boolean
  isShowSkeletonTitle?: boolean
  skeletonAlign?: string
  skeletonWidthTitle?: string
  skeletonWidthValue?: string
  skeletonWidthValueLine2?: string
  title: string
  value?: string
  valueElement?: React.ReactNode
}

export const CreateTicketLabel = (props: TicketLabelProps): JSX.Element => {
  const {
    isLoading = false,
    isRow = false,
    isShowSkeletonTitle = false,
    skeletonAlign = 'start',
    skeletonWidthTitle = '65px',
    skeletonWidthValue = '100%',
    skeletonWidthValueLine2,
    title,
    value,
    valueElement,
  } = props

  const base = 'f-ticket-label'

  return (
    <>
      {isLoading ? (
        <div
          data-testid='skeleton-ticket-label-loading'
          className={`text-align-${skeletonAlign} ${base}__skeleton`}
        >
          {isShowSkeletonTitle && (
            <Skeleton.whiteSkeleton height='18px' width={skeletonWidthTitle} />
          )}
          <Skeleton.whiteSkeleton height='18px' width={skeletonWidthValue} />
          {skeletonWidthValueLine2 && (
            <Skeleton.whiteSkeleton
              height='18px'
              width={skeletonWidthValueLine2}
            />
          )}
        </div>
      ) : (
        <div
          className={`${base}__body ${
            isRow ? `${base}__body--row` : `${base}__body--column`
          }`}
        >
          <span data-testid='text-title' className={`${base}__title`}>
            {getLabel(title)}
          </span>
          {valueElement || (
            <span className={`${base}__value`}>{value || '-'}</span>
          )}
        </div>
      )}
    </>
  )
}
